import { Component, OnInit } from '@angular/core';
import { Libraries } from '../../models/libraries';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'app-get-library-details',
  templateUrl: './get-library-details.component.html',
  styleUrls: ['./get-library-details.component.scss']
})
export class GetLibraryDetailsComponent implements OnInit {

  model = {} as Libraries;
  constructor(
    private route: Router,
    private diag: NbDialogRef<GetLibraryDetailsComponent>,
    public sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
      this.route.events.subscribe(()=>{
      this.diag.close('false');
     });
  }
  getLabelData(text) {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }

  close(){
    this.diag.close();
  }

}
